module.exports = __webpack_public_path__ + "static/media/snowboard_pic.0ab63f60.webp";